$(function() {
    // const $footer = $('body > .site-footer');
    // const footerDefaultHeight = $footer.outerHeight();
    // const $mapContainer = $footer.find('.map-container');

    // // footer height adjust after newsletter form collapse
    // $('.site-footer #group-content-1').on('shown.bs.collapse', function() {
    //     // boostrap event
    //     $mapContainer.height($footer.outerHeight());
    // });

    // $('.site-footer #group-content-1').on('hidden.bs.collapse', function() {
    //     // boostrap event
    //     $mapContainer.height(footerDefaultHeight);
    // });

    // $mapContainer.height(footerDefaultHeight);
});



// WEBPACK FOOTER //
// ./static/js/modules/footer.js